import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import styled from 'styled-components';

export const BouncingDot = styled.div`
  ${({ theme }) => `
    width: 16px;
    height: 16px;
    margin: 3px 6px;
    border-radius: 50%;
    background-color: ${cxTheme.colors.blue.lighten20};
    opacity: 1;
    animation: bouncing-loader 0.6s infinite alternate;

    @keyframes bouncing-loader {
      to {
        opacity: 0.4;
        transform: translateY(-16px);
      }
    }

    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  `}
`;

export const BouncingLoaderWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: center;
  `}
`;

export const LoaderPage = styled.div`
  ${({ theme }) => `
    font-size: 4em;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `}
`;
